import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createRoute,
  deleteRoute,
  getAllRoutes,
  getRouteById,
  updateRoute,
  updateRouteTrackMap,
} from "./routes.service";

export const useGetAllRoutes = (options = {}) => {
  return useQuery({
    queryKey: ["jeep-rally-routes"],
    queryFn: getAllRoutes,
    ...options,
  });
};

export const useGetRouteById = (routeId, options = {}) => {
  return useQuery({
    queryKey: ["jeep-rally-routes", routeId],
    queryFn: () => getRouteById(routeId),
    enabled: Boolean(routeId) && options.enabled !== false,
    ...options,
  });
};

export const useCreateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ payload }) => createRoute(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["jeep-rally-routes"],
      });
    },
  });
};

export const useUpdateRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, payload }) => updateRoute(routeId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-routes"] });
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: ["jeep-rally-routes", variables.routeId],
        });
      }
    },
  });
};

export const useUpdateRouteTrackMapMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId, formData }) =>
      updateRouteTrackMap(routeId, formData),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-routes"] });
      if (variables?.routeId) {
        queryClient.invalidateQueries({
          queryKey: ["jeep-rally-routes", variables.routeId],
        });
      }
    },
  });
};

export const useDeleteRouteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ routeId }) => deleteRoute(routeId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["jeep-rally-routes"] });
    },
  });
};
